<template>
  <b-table-simple :responsive="true" :bordered="bordered">
    <!--  Head  -->
    <b-thead>
      <b-tr>
        <b-th colspan="2">Aways</b-th>
      </b-tr>
    </b-thead>
    <!-- end of head    -->
    <b-tbody>
      <b-tr v-for="away in aways" v-bind:key="away.id">
        <b-td>
          <strong>{{ away.abbreviation }}</strong>
        </b-td>
        <b-td> {{ away.name }} </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
export default {
  name: "SchoolAwaySectionExportLegend",
  props: {
    aways: {
      type: Array,
      required: true,
    },
    bordered: {
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped></style>
